import {
  Box,
  Grid,
  Skeleton,
  Stack,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { useCurrentPageUserId } from '../../../../../hooks/useCurrentPageUserId';
import ArticleLayout from '../../../../../layouts/ArticleLayout';
import { useGetCompanyByUserIdQuery } from '../../../../../store/apiSlice/companyApi';
import Description from './Description';

const NO_DATA = 'No information';

const AboutTab = () => {
  const { userId } = useCurrentPageUserId();
  const {
    data: companyInfoData,
    isLoading,
    refetch,
  } = useGetCompanyByUserIdQuery(userId ?? '', {
    skip: !userId,
  });

  const companyInfo = companyInfoData;
  return (
    <Box
      display="flex"
      flexDirection="column"
      rowGap={{ xs: '16px', xl: '22px' }}
    >
      {isLoading && (
        <Skeleton
          variant="rounded"
          sx={{
            width: '100%',
            marginTop: '20px',
            minHeight: {
              xs: '310px',
              lg: '420px',
            },
          }}
        />
      )}
      {!isLoading && (
        <ArticleLayout
          className="about-article"
          rowGap={8}
          display="flex"
          flexDirection="column"
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h3" textTransform="capitalize">
              about company
            </Typography>
            {/*{isOwnPage && (*/}
            {/*  <SquareIconButton>*/}
            {/*    <EditIcon />*/}
            {/*  </SquareIconButton>*/}
            {/*)}*/}
          </Stack>

          <Grid container rowGap="28px" sx={gridContainerStyles}>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Company name:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.companyName ?? NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Address:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.address || NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                City:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.city || NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                State:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.state || NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Country:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.country || NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Zip code:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.zipCode || NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Phone:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.phone || NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Contact email:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.contactEmail || NO_DATA}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Website:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {companyInfo?.website || NO_DATA}
              </Typography>
            </Grid>
            <Grid item>
              <Description
                data={companyInfoData as any}
                isLoading={isLoading}
                refetch={refetch}
              />
            </Grid>
          </Grid>
        </ArticleLayout>
      )}
    </Box>
  );
};

export default AboutTab;

export const gridContainerStyles: SxProps<Theme> = (theme) => ({
  '& .label': {
    width: 165,
    flexShrink: 0,
  },
  '& .plain-text': {
    fontWeight: 400,
    lineHeight: '140%',
    color: theme.palette.text.primary,

    textAlign: 'left',
    flexGrow: '1',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    minWidth: 0,
  },
  '& .MuiGrid-item': {
    width: '100%',
  },
});
